// app/src/dashboard/widgets/chart/chartTypes.ts

export type Timeframe = "1m" | "5m" | "15m" | "30m" | "1h" | "4h" | "1d" | "1w";

export interface ChartWidgetConfig {
  symbol: string;
  timeframe: Timeframe;
  showTrades: boolean;
  locked: boolean; // locks all settings (symbol auto-follow disabled when true)
}

export const DEFAULT_CHART_CONFIG: ChartWidgetConfig = {
  symbol: "",
  timeframe: "1h",
  showTrades: true,
  locked: false,
};

/** How many days of data to load per timeframe on initial mount.
 * 1m/5m windows must include enough trading days to survive week-end gaps
 * (Yahoo Finance caps 1m at 7 days back, 5m at 60 days back). */
export const TIMEFRAME_WINDOW_DAYS: Record<Timeframe, number> = {
  "1m": 7,
  "5m": 7,
  "15m": 7,
  "30m": 14,
  "1h": 30,
  "4h": 90,
  "1d": 365,
  "1w": 1095,
};
